<template>
	<div>
		<!-- Main -->
		<nav class="uk-navbar-container uk-margin-small-bottom" uk-navbar>
			<div class="uk-navbar-left">
				<span class="uk-navbar-item uk-logo">ToDo一覧ダウンロード</span>
			</div>
			<div class="uk-navbar-right">
				<template v-if="current_staff != null">
					<div class="navbar-item">
						<p class="uk-text-small uk-margin-right uk-margin-remove-bottom">こんにちは、{{ current_staff.display_name }}さん</p>
					</div>
				</template>
				<div class="navbar-item">
					<button class="uk-button uk-text-small uk-button-small uk-button-default" @click="clickLogoutButton">ログアウト</button>
				</div>
			</div>
		</nav>
		<div class="uk-container uk-container-expand uk-margin-medium uk-margin-remove-left uk-margin-remove-right">
			<div class="uk-align-right">
				<router-link class="uk-button uk-button-default" to="/shop">戻る</router-link>
			</div>
		</div>
		<!--/ Main -->
		<div class="uk-container uk-container-expand uk-margin-large-bottom">
			<h1 class="uk-heading-divider">未完了ToDo</h1>
			<button class="uk-button uk-button-default" @click="downloadTodoRunningList">CSVダウンロード</button>
		</div>
		<div class="uk-container uk-container-expand uk-margin-large-bottom">
			<div class="uk-form-horizontal">
				<h1 class="uk-heading-divider">完了ToDo</h1>
				<div id="date_picker" class="uk-child-width-1-2@s uk-child-width-1-2@m uk-text-center" uk-grid>
					<div>
						<label class="uk-form-label" for="start">開始</label>
						<div class="uk-form-controls">
							<template v-if="isMobile()">
								<el-date-picker id="start" name="start" v-model="start_date_picker" format="yyyy/MM/dd" :type="date" :editable="false" :picker-options="date_picker_options" placeholder="YYYY/MM/DD"></el-date-picker>
							</template>
							<template v-else>
								<el-date-picker id="start" name="start" v-model="start_date_picker" format="yyyy/MM/dd" :type="date" :picker-options="date_picker_options" placeholder="YYYY/MM/DD"></el-date-picker>
							</template>
						</div>
					</div>
					<div>
						<label class="uk-form-label" for="start">終了</label>
						<div class="uk-form-controls">
							<template v-if="isMobile()">
								<el-date-picker id="end" name="end" v-model="end_date_picker" format="yyyy/MM/dd" :type="date" :editable="false" :picker-options="date_picker_options" placeholder="YYYY/MM/DD"></el-date-picker>
							</template>
							<template v-else>
								<el-date-picker id="end" name="end" v-model="end_date_picker" format="yyyy/MM/dd" :type="date" :picker-options="date_picker_options" placeholder="YYYY/MM/DD"></el-date-picker>
							</template>
						</div>
					</div>
				</div>
				<p>期間を指定した場合、その期間中に完了したToDoの一覧が出力されます。</p>
				<button class="uk-button uk-button-default" @click="downloadTodoFinishedList">CSVダウンロード</button>
			</div>
		</div>
	</div>
</template>

<script>

	import StaffAuth from '@/api/StaffAuth'
	import CsvExport from '@/api/CsvExport'
	import Role from '@/api/Role'
	import CallCenterAuth from '@/api/CallCenterAuth'
	import BranchOfficeAuth from '@/api/BranchOfficeAuth'
	import MainOfficeAuth from '@/api/MainOfficeAuth'

	export default {
		name: 'ShopTodoListDownloadPage',
		comments: [],
		data () {
			return {
				current_staff: null,
				start_date_picker: '',
				end_date_picker: '',
				date_picker_options: {
					format: 'yyyy/MM/dd'
				}
			}
		},
		filters: {
			moment: function (date) {
				return moment(date).format('YYYY/MM/DD HH:mm')
			}
		},
		methods: {
			clickLogoutButton () {
				let self = this

				StaffAuth.logout().then(function (response) {
					// CallCenterAuth.logout().then(function (response) {
						// BranchOfficeAuth.logout().then(function (responase) {
							// MainOfficeAuth.logout().then(function (response) {
								self.$router.push('/')
								location.reload()
							// })
						// })
					// })
				})
			},
			downloadTodoFinishedList () {
				let self = this
				StaffAuth.current().then(function (response) {
					// let start = $('#start').val()
					// let end = $('#end').val()
					let start = moment(self.start_date_picker).format('YYYY-MM-DD')
					let end = moment(self.end_date_picker).format('YYYY-MM-DD')

					let params = new URLSearchParams()
					params.append('code', response.data.data.shop.code)

					if (start != null) {
						params.append('start', start)
					}
					if (end != null) {
						params.append('end', end)
					}

					CsvExport.todoFinished(params).then(function (response) {
						window.location.href = response.data.data
					})
				})
			},
			downloadTodoRunningList () {
				StaffAuth.current().then(function (response) {
					let staff = response.data.data

					let params = new URLSearchParams()
					params.append('code', staff.shop.code)

					CsvExport.todoRunning(params).then(function (response) {
						window.location.href = response.data.data
					})
				})
			},
			isMobile () {
				let ua = navigator.userAgent

				if (ua.indexOf('iPhone') > 0 || ua.indexOf('iPad') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('Android') > 0 || ua.indexOf('Mobile') > 0) {
					return true
				} else {
					return false
				}
			}
		},
		created () {
		},
		beforeMount () {
		},
		mounted () {
			let self = this

			Role.show().then(function (response) { // 権限取得
				let data = response.data

				if (data.data.is_admin_staff != true) { // 権限が無い場合
					self.$router.push('/')
				}
			})

			StaffAuth.current().then(function (response) {
				self.current_staff = response.data.data
			})
		}

	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
</style>
<style lang="scss">
	.el-date-editor {
		width: 100% !important;
	}
	.el-input__inner {
		border-radius: 0;
	}
</style>



// WEBPACK FOOTER //
// src/components/page/ShopTodoListDownloadPage.vue